@if (isBom()) {
  @if (overview()?.bomComment; as bomComment) {
    <app-bom-comment-card
      [comment]="bomComment"
      [updatedBy]="overview()?.bomUpdatedBy ?? null"
      [updatedAt]="overview()?.bomUpdatedAt ?? null"
    />
  }
} @else {
  <div class="mark-bom-action">
    <gc-button
      [variant]="'danger'"
      [size]="'small'"
      [icon]="'triangleExclamation'"
      [iconPosition]="'left'"
      [disabled]="isFormOpen() || isSaving()"
      (clicked)="openForm()"
    >
      {{ 'installationReportV2.orderOverviewTab.markAsBom' | translate }}
    </gc-button>
  </div>
  @if (isFormOpen()) {
    <app-bom-comment-form
      [isSaving]="isSaving()"
      (confirmed)="bomMarked.emit($event)"
      (cancelled)="closeForm()"
    />
  }
}
